import moment from "moment"

/**
 * Factory function returning a new signupTokenService instance.
 *
 * @param {Object} storage An object that can talk to a storage API
 * @param {Object} client Http client object
 * @returns {Object} The signupTokenService instance
 */
export const signupTokenService = (storage, client) => {
  let _token
  let _client = client
  let _storage = storage

  function hasUnexpiredToken() {
    _token = storage.getItem("signup-token")

    if (!_token) {
      return false
    }

    return moment().isBefore(moment(_token.expiresAt))
  }

  /**
   * Exchanges a captcha token for a signin token.
   *
   * @param string captcha The token from a reCaptcha response
   * @returns {Promise} A Promise resolving to a signup token
   */
  function newToken(captcha) {
    return _client.post(`${process.env.VUE_APP_API_URL}/signup-tokens`, {captcha}).then(
      res => {
        _token = res.data
        _storage.setItem("signup-token", _token)
        return _token
      },
      err => err
    )
  }

  return {
    /**
     * Requires a verified reCaptcha response token to exchange for a
     * signup token. A valid signup token will be cached in local storage.
     *
     * @param {string} captcha - The token from a reCaptcha response
     * @returns {(Object|Promise)} - A signup token or a Promise resolving to one
     */
    getToken: (captcha) => {
      return hasUnexpiredToken() ? Promise.resolve(_token) : newToken(captcha)
    },

    /**
     * Clears the signup-token out of the configured storage driver.
     */
    clear: () => {
      return _storage.removeItem("signup-token")
    }
  };
};
